export class RateCalculationGuard {
  private id = 0;
  private controller?: AbortController;

  begin(): { id: number; controller: AbortController } {
    this.controller?.abort();

    const controller = new AbortController();
    this.controller = controller;

    return { id: ++this.id, controller };
  }

  isCurrent(id: number): boolean {
    return id === this.id;
  }

  abort(): void {
    this.controller?.abort();
  }
}
